<template>
  <router-link v-bind="{ ...$props, ...$attrs }" :to="to">
    <slot></slot> <v-icon color="secondary" small>fa-light fa-arrow-right</v-icon>
  </router-link>
</template>

<script>
export default {
  props: {
    to: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
a {
  color: var(--v-secondary-base);
  text-decoration: none;

  .v-icon {
    margin-left: 2px;
  }

  &:hover {
    color: var(--v-primary-base);

    .v-icon {
      transform: scale(1.2);
    }
  }
}
</style>
